export { ModalHeader } from "./Components/ModalHeader";
export { InfoBox } from "./Components/InfoBox";
export * from "./Functions/Modal";
export { UIFeedback } from "./Functions/UIFeedback";
export { UIString } from "./Functions/UIString";
export { CopyToClipboard } from "./Functions/CopyToClipboard";
export const _x = (id) => document.getElementById(id);
